import React, {useCallback, useEffect, useState} from 'react';
import Dropdown from "../../components/Dropdown";
import {getDataByUrl, getSelectOptions} from "../api";
import {nameForUrl, settingsWithoutThis} from "../utils";
import StateDropdown from "../../components/Dropdowns/StateDropdown";
import debounce from "lodash.debounce";

const SelectFilter = ({filter, column, setFilter, multiple, isStatus, filterParams, isDictionary}) => {

    const [options, setOptions] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);

    const changeFilter = (v) => {
        setSelectOptions(options.filter(o => (multiple || isStatus) ? v.includes(o.value) : o.value === v))
        setFilter({
            fieldName: column.fieldName,
            operation: 'in',
            value: v ? v.toString() : null
        })
    }

    const getOptions = (column, filterParams) => {
        // Если у колонки есть статические опции, используем их
        if (column.options && Array.isArray(column.options)) {
            setOptions(column.options.map(e => ({
                value: e.value,
                key: e.key,
                text: e.text,
                code: e.code
            })));
            return;
        }

        // Иначе загружаем через API
        const f = isDictionary ? getDataByUrl : getSelectOptions;
        f(column.optionsUrl || nameForUrl(column.fieldName), filterParams)
            .then(d => {
                setOptions((d.entries || []).map(e => ({
                    value: e.id.toString(),
                    key:  e.id,
                    text: e.name,
                    code: e.code
                })))
            })
            .catch(e => console.log(e))
    }

    const getOptionsDebounce = useCallback(debounce(getOptions, 2000), []);

    useEffect(() => {
        getOptionsDebounce(column, settingsWithoutThis(filterParams, column.fieldName));
    }, [filterParams])

    const getValues = () => {
        return ((filter || {}).value || '').split(',').filter(v => v !== '');
    }

    const allOptions = () => {
        let opts = [...options];
        (selectOptions && selectOptions.length) && selectOptions.forEach(s => {
            if (!(opts.map(o => o.value).includes(s.value))) {
                opts.push(s)
            }
        })
        return opts;
    }

    return (
        isStatus
            ? <StateDropdown
                placeholder={column.title}
                compact
                options={allOptions()}
                value={getValues()}
                onChange={(e, {value}) => changeFilter(value)}
            />
            : <Dropdown
                className={!column.disableSort ? 'filter-with-sort' : ''}
                clearable
                multiple={multiple}
                name={column.fieldName}
                placeholder={column.title}
                selectOnNavigation={false}
                selectOnBlur={false}
                compact
                options={allOptions()}
                value={multiple ? getValues() : ((filter || {}).value || null)}
                onChange={(e, {value}) => changeFilter(value)}
            />
    );
};

export default SelectFilter;


// WEBPACK FOOTER //
// ./App/grids/filters/select.jsx